import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { CodeTableService } from "src/app/listing/code-table.service";
import { ListingService } from "./listing.service";
import { LoonFnFactoriesService } from "./loon-fn-factories.service";
import { ComponentTypeSK, UiArguments, dottedName } from "@recore-solutions/nstar-lib";

@Injectable({ providedIn: "root" })
export class BuilderFnFactoriesService extends LoonFnFactoriesService {
	constructor(
		protected listingService: ListingService,
		protected codeTableService?: CodeTableService
	) {
		super(listingService, codeTableService);
	}

	queryTransformFn = (
		uiArguments: UiArguments
	): ((term: any, additionalParams?: any[]) => HttpParams | null) => {
		const parent = this.getParentFromUiArguments(uiArguments);
		const component = this.getPrimaryComponent(uiArguments);
		const children = this.getChildrenFromUiArguments(uiArguments);
		const reduceToNameAndValuePairs = this.reduceToNameAndValuePairs(uiArguments, children);

		if (!children?.length) {
			return () => new HttpParams();
		}

		const dependent = children.map(this.getDependentOf(uiArguments)).filter((u) => !!u);
		const componentDottedName = dottedName(component);
		const alternativeProperty = component.longName || componentDottedName;

		return (term: any) => {
			if (parent.componentTypeSK === ComponentTypeSK.SearchSelect && !term) {
				return null;
			}
			let nameAndValuePairs: { [name: string]: any } = {};
			if (!term || typeof term === "string") {
				nameAndValuePairs = dependent.reduce(reduceToNameAndValuePairs, nameAndValuePairs);
			}
			if (this.termIsDefined(term)) {
				const propertyName = typeof term === "string" ? alternativeProperty : componentDottedName;
				nameAndValuePairs[propertyName] = this.getFormattedTerm(term, "FullTextSearch", true);
			}
			return this.getHttpParamsFromNameAndValuePairs(nameAndValuePairs);
		};
	};

	searchFn = () => (httpParams: HttpParams) => {
		if (!httpParams) {
			return of([]);
		}

		return this.listingService.getGenericProcValues("Polaris.spGetBuilder", httpParams);
	};
}
